import React from 'react';
import PropTypes from 'prop-types';
import AuthenticatedUserView from 'refactored/ui/views/authenticatedUserView';

import SummaryComponent from 'components/summary';
import FeasibilityContextProvider from 'hooks/useFeasibility';

const Summary = ({ className, handleBack }) => (
  <FeasibilityContextProvider>
    <AuthenticatedUserView className={className} handleBack={handleBack}>
      <section className="main" role="main">
        <SummaryComponent />
      </section>
    </AuthenticatedUserView>
  </FeasibilityContextProvider>
);

Summary.propTypes = {
  className: PropTypes.string,
  handleBack: PropTypes.func.isRequired,
};

Summary.defaultProps = {
  className: '',
};

export default Summary;
